import AgentInventory from "../Agents"

import type { TabComponentProps } from "@/organisms/Drawers/components/TabsDrawerTemplate"

// Thin tab entry for the CodeRepositoryDrawer "Agents" tab (internal tenants only — gated in
// CodeRepositoryDrawer on the isInternalTenant feature flag). The heavy inventory view is lazily
// loaded by AgentInventory, so it is not part of the bundle shipped to non-internal users.
export const AgentsTab = (props: TabComponentProps) => {
  return <AgentInventory {...props} />
}
